<template>
  <div>
    <b-row>
      <b-col class="mb-1">
        <b-link :to="{ name: 'InvoiceInfo-View' }">
          <feather-icon icon="ArrowLeftIcon" />
          <span class="align-middle ml-50">Back to List</span>
        </b-link>
      </b-col>
    </b-row>
    <b-card title="Create New Invoice Information">
      <validation-observer ref="simpleRules">
        <form ref="form" @submit.stop.prevent="validationForm">
          <b-row>
            <b-col md="6">
              <b-form-group label="Company Name" label-for="company">
                <validation-provider
                  #default="{ errors }"
                  name="company"
                  rules="required"
                >
                  <b-form-select
                    id="name"
                    v-model="requestData.companyId"
                    :options="companies"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Company Address" label-for="company-address">
                <validation-provider
                  #default="{ errors }"
                  name="Company Address"
                  rules="required"
                >
                  <b-form-input
                    id="company-address"
                    v-model="requestData.address"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Company Telephone"
                label-for="company-telephone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Company Telephone"
                  rules="required"
                >
                  <b-form-input
                    id="company-telephone"
                    type="number"
                    v-model="requestData.telephone"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Company Fax" label-for="company-fax">
                <validation-provider
                  #default="{ errors }"
                  name="Company Fax"
                  rules="required"
                >
                  <b-form-input
                    id="company-fax"
                    v-model="requestData.fax"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Company P.O.Box" label-for="company-pobox">
                <validation-provider
                  #default="{ errors }"
                  name="Company P.O.Box"
                  rules="required"
                >
                  <b-form-input
                    id="company-pobox"
                    v-model="requestData.poBox"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Body Statement" label-for="body-statement">
                <validation-provider
                  #default="{ errors }"
                  name="Body Statement"
                  rules="required"
                >
                  <b-form-textarea
                    id="body-statement"
                    v-model="requestData.bodyStatement"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Bank Name" label-for="bank-name">
                <validation-provider
                  #default="{ errors }"
                  name="Bank Name"
                  rules="required"
                >
                  <b-form-input
                    id="bank-name"
                    v-model="requestData.bankName"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Beneficiary Name"
                label-for="beneficiary-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Beneficiary Name"
                  rules="required"
                >
                  <b-form-input
                    id="beneficiary-name"
                    v-model="requestData.beneficiaryName"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Account Number" label-for="account-number">
                <validation-provider
                  #default="{ errors }"
                  name="Account Number"
                  rules="required"
                >
                  <b-form-input
                    id="account-number"
                    v-model="requestData.accountNumber"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Signatory Name" label-for="signatory-name">
                <validation-provider
                  #default="{ errors }"
                  name="Signatory Name"
                  rules="required"
                >
                  <b-form-input
                    id="signatory-name"
                    v-model="requestData.signatoryName"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Signatory Position"
                label-for="signatory-position"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Signatory Position"
                  rules="required"
                >
                  <b-form-input
                    id="signatory-position"
                    v-model="requestData.signatoryPosition"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Footer Note" label-for="footer-note">
                <validation-provider
                  #default="{ errors }"
                  name="Footer Note"
                  rules="required"
                >
                  <b-form-textarea
                    id="Footer Note"
                    v-model="requestData.footerNote"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </validation-observer>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
    <b-col class="d-flex justify-content-end">
      <b-button
        class="center"
        variant="success"
        @click.prevent="validationForm"
      >
        <span>Save</span>
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
  BForm,
  BFormTextarea,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
    BForm,
    BFormTextarea,
  },
  data() {
    return {
      isLoading: false,
      requestData: {
        companyId: 0,
        address: "",
        telephone: "",
        fax: "",
        poBox: "",
        bodyStatement: "",
        bankName: "",
        beneficiaryName: "",
        accountNumber: "",
        signatoryName: "",
        signatoryPosition: "",
        footerNote: "",
      },
      required,
      companies: [],
    };
  },
  created() {
    this.getCompanies();
  },
  methods: {
    getCompanies() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetAllCompanies")
        .then((res) => {
          res.companies.map((c) =>
            this.companies.push({ value: c.id, text: c.name })
          );
          this.isLoading = false;
        })
        .catch((err) => console.log(err), (this.isLoading = false));
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          axios
            .post(
              "/Invoice/api/V1.0/Invoice/CreateInvoiceInfo",
              this.requestData
            )
            .then((res) => {
              this.isLoading = false;
              console.log(res);
              this.$bvModal
                .msgBoxOk("Data was submitted successfully", {
                  title: "Confirmation",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.$router.push("/report/invoiceinfo");
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form);
      });
    },
  },
};
</script>
